module.exports = __webpack_public_path__ + "img/sc-logo-1.58f02a2d.png";